module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('span', [(!_vm.revealAnswers) ? _vm._c('span', {
    directives: [{
      name: "scroll-in-view-when",
      rawName: "v-scroll-in-view-when",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "clex-keyword",
    class: {
      active: _vm.active, answered: _vm.answered
    },
    style: (_vm.style),
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.select($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.visibleContent))]) : _vm._c('span', {
    staticClass: "clex-keyword answer",
    class: {
      correct: _vm.answerIsCorrect, wrong: !_vm.answerIsCorrect
    },
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.answerDiff)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57b44e60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-studier/ImageKeyword.vue
// module id = 667
// module chunks = 1